import React, { useState } from "react";
import moment from "moment";
import { Button, FormGroup, ControlLabel, FormControl, Row, Col, Tabs, Tab, Checkbox, Modal, ProgressBar } from "react-bootstrap";
import FormControlLanguage from "../../../UI/FormControlLanguage";
import Select from "react-select";
import HelpHintButton from "components/HelpHintButton";
import InputDateTime from "../../../InputDateTime";
import { useUserContext } from "../../../../context";
import { Event } from "components/Comet";
// import { addTickets, getTickets } from "../../../../../api/cp/ticket";
import { updateEvent } from "../../../../../api/cp/event";
import { eventModuleMainUpdate } from "../../../../../api/cp/eventModuleMain";
import { eventModuleBrandingUpdate } from "../../../../../api/cp/eventModuleBranding";
import { addClientEmptyRegistrations } from "../../../../../api/cp";
import { updateEventModuleAuth } from "../../../../../api/cp/eventModuleAuth";
import { useNotificationContext } from "../../../UI/Notifications";
import Loading from "../../../Loading";

const playerVersionsOptions = [
    { value: 'watch', label: 'Watch', },
    { value: 'platform', label: 'Platform', }
];

const participationTypesOptions = [
    { value: 'online', label: 'Online', },
    { value: 'offline', label: 'Offline', },
    { value: 'hybrid', label: 'Гибрид', }
];

const languageOptions = [
    { value: null, label: 'Авто' },
    { value: 'ru', label: 'Русский' },
    { value: 'en', label: 'Английский' },
];

const MAX_EMPTY_REGS = 50000;

export default ({ event, setEvent }) => {
    const { userIsAdmin } = useUserContext();
    const { showNotification } = useNotificationContext();
    const [isSaving, setSaving] = useState(false);
    const [emptyRegsQty, setEmptyRegsQty] = useState(1);
    const [showTickets, setShowTickets] = useState(null);
    const [emptyRegsTask, setEmptyRegsTask] = useState('');

    // const handleGetTickets = () => {
    //     getTickets(event.eventPassword)
    //         .then(tickets => setShowTickets(tickets))
    //         .catch(e => console.error(e))
    // }

    const handleFinishEmptyRegs = () => {
        setEmptyRegsTask('');
        setEmptyRegsQty(1);
        showNotification({ message: "Регистрации успешно созданы", type: 'success' })
    }

    const handleAddEmptyRegs = () => {
        if (emptyRegsQty) {
            addClientEmptyRegistrations(event.eventKey, { quantity: emptyRegsQty, participationType: event.participationType })
                .then(({ task }) => setEmptyRegsTask(task))
                .catch(e => console.error(e))
        }
    }

    const onSaveEvent = (data) => {
        setSaving(true);

        updateEvent(event.id, data)
            .then(response => setEvent(event => ({ ...event, ...response })))
            .catch(e => console.error(e))
            .finally(() => setSaving(false))
    }

    const onSaveEventModuleMain = (data) => {
        setSaving(true);

        eventModuleMainUpdate(event.eventKey, data)
            .then(moduleMain => setEvent(event => ({ ...event, moduleMain })))
            .catch(e => console.error(e))
            .finally(() => setSaving(false))
    }

    const onSaveEventModuleBranding = (data) => {
        setSaving(true);

        eventModuleBrandingUpdate(event.eventKey, data)
            .then(moduleBranding => setEvent(event => ({ ...event, moduleBranding })))
            .catch(e => console.error(e))
            .finally(() => setSaving(false))
    }

    const onSaveEventModuleAuth = (data) => {
        setSaving(true);

        updateEventModuleAuth(event.eventKey, data)
            .then(moduleAuth => setEvent(event => ({ ...event, moduleAuth })))
            .catch(e => console.error(e))
            .finally(() => setSaving(false))
    }

    const handleTimeTange = (limit, value) => {
        setEvent(event => {
            const _event = { ...event };
            _event[limit] = value;
            if (_event.timeStart > _event.timeStop) {
                _event[limit === 'timeStart' ? 'timeStop' : 'timeStart'] = value
            }
            return _event;
        })
    }

    return <div>
        <FormGroup>
            <ControlLabel>ID</ControlLabel>
            <FormControl
                type="text"
                value={event.id}
                readOnly
            />
        </FormGroup>
        <FormGroup >
            <ControlLabel>Название мероприятия</ControlLabel>
            <FormControlLanguage
                type="text"
                values={{
                    ru: event.name_ru || '',
                    en: event.name_en || '',
                }}
                onChange={{
                    ru: (e) => setEvent(event => ({ ...event, name_ru: e.target.value })),
                    en: (e) => setEvent(event => ({ ...event, name_en: e.target.value })),
                }}
                onBlur={() => onSaveEvent({ name_ru: event.name_ru, name_en: event.name_en })}
                disabled={isSaving}
            />
        </FormGroup>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
            <div style={{ flex: 1 }}>
                <FormGroup >
                    <ControlLabel>Время начала</ControlLabel>
                    <InputDateTime
                        value={event.timeStart}
                        max={event.stream?.length && event.stream.reduce((min, stream) => stream.timeStart < min ? stream.timeStart : min, event.stream[0].timeStart)}
                        onChange={(value) => handleTimeTange('timeStart', value)}
                        onBlur={() => onSaveEvent({ timeStart: event.timeStart, timeStop: event.timeStop })}
                        disabled={!userIsAdmin || isSaving}
                        errorMessage={{ max: 'Исправьте время в залах, некоторые залы выходят за пределы начала мероприятия' }}
                    />
                </FormGroup>
            </div>
            <div style={{ flex: 1 }}>
                <FormGroup >
                    <ControlLabel>Время окончания</ControlLabel>
                    <InputDateTime
                        value={event.timeStop}
                        min={event.stream?.length && event.stream.reduce((max, stream) => stream.timeStop > max ? stream.timeStop : max, event.stream[0].timeStop)}
                        onChange={(value) => handleTimeTange('timeStop', value)}
                        onBlur={() => onSaveEvent({ timeStart: event.timeStart, timeStop: event.timeStop })}
                        disabled={!userIsAdmin || isSaving}
                        errorMessage={{ min: 'Исправьте время в залах, некоторые залы выходят за пределы окончания мероприятия' }}
                    />
                </FormGroup>
            </div>
        </div>
        <FormGroup >
            <ControlLabel>Язык мероприятия</ControlLabel>
            <Select
                value={languageOptions.find(({ value }) => event.locale === value) || languageOptions[0]}
                onChange={({ value: locale }) => onSaveEvent({ locale })}
                options={languageOptions}
                isDisabled={isSaving}
                placeholder="Выберите язык"
            />
        </FormGroup>
        <FormGroup>
            <Checkbox
                checked={event.storeRecordsEnabled}
                onChange={(e) => onSaveEvent({ storeRecordsEnabled: e.target.checked })}
                disabled={isSaving}
            >Сохранить запись трансляции</Checkbox>
        </FormGroup>
        {userIsAdmin && <>
            <FormGroup >
                <ControlLabel>Срок доступности мероприятия</ControlLabel>
                {event.expire !== null && (
                    <FormControl
                        type="date"
                        value={event.expire === null ? "" : moment.unix(event.expire).format('yyyy-MM-DD')}
                        onChange={(e) => setEvent(event => ({ ...event, expire: moment(e.target.value).unix() }))}
                        onBlur={() => onSaveEvent({ expire: event.expire })}
                        disabled={isSaving}
                    />
                )}
            </FormGroup>
            <FormGroup>
                <Checkbox
                    checked={event.expire === null}
                    onChange={(e) => {
                        const now = moment().unix();
                        onSaveEvent({ expire: e.target.checked ? null : (event.timeStop > now ? event.timeStop : now) + 30 * 24 * 3600 });
                    }}
                    disabled={isSaving}
                >На сайте COMDI</Checkbox>
            </FormGroup>
        </>}
        <FormGroup >
            <ControlLabel>Версия плеера</ControlLabel>
            <Select
                value={playerVersionsOptions.find(({ value }) => event.moduleMain.frontendPage === value) || playerVersionsOptions[0]}
                onChange={({ value }) => onSaveEventModuleMain({ frontendPage: value })}
                options={playerVersionsOptions}
                isDisabled={isSaving}
            />
        </FormGroup>
        <FormGroup >
            <ControlLabel>Формат участия</ControlLabel>
            <Select
                value={participationTypesOptions.find(({ value }) => event.participationType === value) || participationTypesOptions[0]}
                onChange={({ value }) => onSaveEvent({ participationType: value })}
                options={participationTypesOptions}
                isDisabled={isSaving}
            />
        </FormGroup>
        <FormGroup>
            <Checkbox
                checked={event.moduleBranding.testSystem}
                onChange={(e) => onSaveEventModuleBranding({ testSystem: e.target.checked })}
                disabled={isSaving}
            >Системные сообщения</Checkbox>
        </FormGroup>
        <FormGroup>
            <Checkbox
                checked={event.private}
                onChange={(e) => onSaveEvent({ private: e.target.checked })}
                disabled={isSaving}
            >Платный просмотр</Checkbox>
        </FormGroup>
        {(event.private && userIsAdmin) && <>
            <Row>
                {/* <Col xs={6}>
                    <FormGroup >
                        <ControlLabel>Лимит билетов</ControlLabel>
                        <FormControl
                            type="number"
                            value={event.moduleMain.ticketLimit}
                            onChange={(e) => setEvent(event => ({ ...event, moduleMain: { ...event.moduleMain, ticketLimit: e.target.value } }))}
                            onBlur={() => onSaveEventModuleMain({ ticketLimit: event.moduleMain.ticketLimit })}
                            disabled={isSaving}
                        />
                    </FormGroup>
                </Col> */}
                <Col xs={6}>
                    <FormGroup >
                        <ControlLabel>Добавить регистрации</ControlLabel>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <FormControl
                                type="number"
                                min={1}
                                max={MAX_EMPTY_REGS}
                                value={emptyRegsQty}
                                onChange={(e) => setEmptyRegsQty(e.target.value > MAX_EMPTY_REGS ? MAX_EMPTY_REGS : e.target.value)}
                                disabled={isSaving}
                            />
                            <Button onClick={handleAddEmptyRegs}>Добавить</Button>
                        </div>
                    </FormGroup>
                    {/* <div style={{ display: 'flex', justifyContent: 'end' }}><Button onClick={handleGetTickets}>Список</Button></div> */}
                </Col>
            </Row>
        </>}
        <Row>
            <Col xs={6}>
                <FormGroup>
                    <ControlLabel>
                        Лимит просмотров
                        <HelpHintButton>
                            <p>Возможность устанавливать, с какого количества устройств разрешен просмотр в одной учетке</p>
                        </HelpHintButton>
                    </ControlLabel>
                    <FormControl
                        type="number"
                        value={event.moduleAuth.maxActiveClientDevices}
                        disabled={isSaving}
                        onChange={(e) => setEvent(event => ({ ...event, moduleAuth: { maxActiveClientDevices: e.target.value } }))}
                        onBlur={(e) => onSaveEventModuleAuth({ maxActiveClientDevices: !!e.target.value ? +e.target.value : null })}
                    />
                </FormGroup>
            </Col>
        </Row>
        <Modal
            show={!!showTickets}
            onHide={() => setShowTickets(null)}
        >
            <Modal.Header closeButton>
                <Modal.Title>Билеты</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <TicketsModal
                    event={event}
                    tickets={showTickets}
                />
            </Modal.Body>
        </Modal>
        <Modal show={!!emptyRegsTask} >
            <Modal.Header >
                <Modal.Title>Создание регистраций</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <EmptyRegsModal task={emptyRegsTask} initRegs={emptyRegsQty} onFinish={handleFinishEmptyRegs} />
            </Modal.Body>
        </Modal>
    </div>
}

const EmptyRegsModal = ({ task, initRegs, onFinish }) => {

    const [current, setCurrent] = useState(0);
    const [total, setTotal] = useState(initRegs);

    const taskHandler = (data) => {
        if (!data || data.taskKey !== task) return;
        setCurrent(data.processed);
        setTotal(data.quantity);

        if (data.status === 'done') {
            setTimeout(() => onFinish(), 500)
        }
    }

    return <>
        <div style={{ height: '20rem', display: 'flex', flexDirection: 'column', gap: '1rem', alignItems: 'center', justifyContent: 'center' }}>
            <Loading />
            <p>Пожалуйста, не закрывайте это окно и дождитесь завершения создания регистраций</p>
            <p>Создано <b>{current}</b> из <b>{total}</b></p>
        </div>
        <ProgressBar active now={(current / total) * 100} />
        <Event event="task:create-emptyClientRegistrations" handler={taskHandler} />
    </>
}

const TicketsModal = ({ tickets }) => {

    const getTicketUrl = (ticket, params) => {
        let url = `https://${document.location.host}/watch/${ticket.ticket}`;
        if (params) {
            const query = [];
            Object.keys(params).forEach(key => {
                const value = params[key];
                if (key === 'lang' && value === 'ru') return;
                query.push([key, value].join('='));
            })
            if (query.length) {
                url += '?' + query.join('&');
            }
        }
        return url;
    }

    return <Tabs id="tickets-tabs">
        {['ru', 'en'].map(lang => <Tab key={lang} eventKey={lang} title={lang.toUpperCase()}>
            <div style={{ marginTop: '0.5rem' }}>
                {tickets?.map((ticket, index) => <div
                    key={ticket.id}
                    style={{ width: '100%', padding: '0.75rem 0', borderTop: index && '1px solid #ddd' }}
                >{getTicketUrl(ticket, { lang })}
                </div>)}
            </div>
        </Tab>)}
    </Tabs>
}